module.exports = __webpack_public_path__ + "static/RelojDurcal_360-126200a6f30bfbb51a8fbba1043040fa.gif";